
  import { integrationsConfigService } from '@/services/integrations/integrationsConfigService';
  import { Instance } from '@/services/integrations/types';
  import { useIntegrationDetailsStore } from '@/stores/integrationDetails';
  import { Button } from '@/ui/components/Button';
  import { Modal } from '@/ui/components/Modal';
  import { INTEGRATIONS_SINGLE_STEP_CONFIRMATION_MODAL_WIDTH } from '@/ui/components/modals/constants';
  import Spinner from '@/ui/components/Spinner.vue';
  import { computed, defineComponent, ref } from 'vue';

  export default defineComponent({
    components: {
      Spinner,
      Modal,
      Button,
    },
    setup() {
      const store = useIntegrationDetailsStore();
      const integration = store.integration!;
      const width = `${INTEGRATIONS_SINGLE_STEP_CONFIRMATION_MODAL_WIDTH}px`;
      const configVariable = integrationsConfigService.getSingleConfigVariable(integration);
      const loading = ref(false);
      const connected = ref(false);
      const CHECK_INTERVAL = 1000;
      let popup: Window | null;

      let instance: Instance;

      const startAuthentication = async () => {
        loading.value = true;
        instance = await integrationsConfigService.createInstance(integration);
        const authorizeUrl = integrationsConfigService.getAuthorizeUrl(instance);
        popup = window.open(authorizeUrl!, '', 'width=800, height=800');
        waitForConnection();
      };

      const waitForConnection = () => {
        setTimeout(checkConnection, CHECK_INTERVAL);
      };

      const checkConnection = async () => {
        const isConnected = await integrationsConfigService.checkSingleStepConnection(instance);
        if (isConnected) {
          await integrationsConfigService.deployInstance(instance, integration);
          loading.value = false;
          connected.value = true;
        }

        if (popup?.closed) {
          loading.value = false;
        }

        if (loading.value) {
          setTimeout(checkConnection, CHECK_INTERVAL);
        }
      };

      const onClose = () => {
        store.closeModal();
        loading.value = false;
        connected.value = false;
      };

      return {
        configVariable,
        startAuthentication,
        loading,
        connected,
        width,
        isOpen: computed(() => store.isModalOpen),
        onClose,
      };
    },
  });
